import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = {
  class: "card-header border-0",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_package_create_details",
  "aria-expanded": "true",
  "aria-controls": "kt_package_create_details"
}
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = {
  id: "kt_package_create_details",
  class: "collapse show"
}
const _hoisted_6 = { class: "card-body border-top p-9" }
const _hoisted_7 = { class: "row mb-6" }
const _hoisted_8 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_9 = { class: "col-lg-8 fv-row" }
const _hoisted_10 = { class: "fv-plugins-message-container" }
const _hoisted_11 = { class: "fv-help-block" }
const _hoisted_12 = { class: "row mb-6" }
const _hoisted_13 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_14 = { class: "col-lg-8 fv-row" }
const _hoisted_15 = { class: "fv-plugins-message-container" }
const _hoisted_16 = { class: "fv-help-block" }
const _hoisted_17 = { class: "row mb-6" }
const _hoisted_18 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_19 = { class: "col-lg-8 fv-row" }
const _hoisted_20 = { class: "fv-plugins-message-container" }
const _hoisted_21 = { class: "fv-help-block" }
const _hoisted_22 = { class: "row mb-6" }
const _hoisted_23 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_24 = { class: "col-lg-8 fv-row" }
const _hoisted_25 = { class: "fv-plugins-message-container" }
const _hoisted_26 = { class: "fv-help-block" }
const _hoisted_27 = { class: "row mb-6" }
const _hoisted_28 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_29 = { class: "col-lg-8 fv-row" }
const _hoisted_30 = { class: "fv-plugins-message-container" }
const _hoisted_31 = { class: "fv-help-block" }
const _hoisted_32 = { class: "row mb-6" }
const _hoisted_33 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_34 = { class: "col-lg-8 fv-row" }
const _hoisted_35 = { class: "fv-plugins-message-container" }
const _hoisted_36 = { class: "fv-help-block" }
const _hoisted_37 = { class: "row mb-6" }
const _hoisted_38 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_39 = { class: "col-lg-8 fv-row" }
const _hoisted_40 = { class: "fv-plugins-message-container" }
const _hoisted_41 = { class: "fv-help-block" }
const _hoisted_42 = { class: "row mb-6" }
const _hoisted_43 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_44 = { class: "col-lg-8 fv-row" }
const _hoisted_45 = {
  value: "",
  disabled: "",
  selected: ""
}
const _hoisted_46 = ["value"]
const _hoisted_47 = { class: "fv-plugins-message-container" }
const _hoisted_48 = { class: "fv-help-block" }
const _hoisted_49 = { class: "row mb-6" }
const _hoisted_50 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_51 = { class: "col-lg-8 fv-row" }
const _hoisted_52 = { class: "fv-plugins-message-container" }
const _hoisted_53 = { class: "fv-help-block" }
const _hoisted_54 = { class: "row mb-6" }
const _hoisted_55 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_56 = { class: "col-lg-8 fv-row" }
const _hoisted_57 = { class: "fv-plugins-message-container" }
const _hoisted_58 = { class: "fv-help-block" }
const _hoisted_59 = { class: "row mb-6" }
const _hoisted_60 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_61 = { class: "col-lg-8 fv-row" }
const _hoisted_62 = { class: "fv-plugins-message-container" }
const _hoisted_63 = { class: "fv-help-block" }
const _hoisted_64 = { class: "row mb-6" }
const _hoisted_65 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_66 = { class: "col-lg-8 fv-row" }
const _hoisted_67 = { class: "fv-plugins-message-container" }
const _hoisted_68 = { class: "fv-help-block" }
const _hoisted_69 = { class: "row mb-6" }
const _hoisted_70 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_71 = { class: "col-lg-8 fv-row" }
const _hoisted_72 = ["placeholder"]
const _hoisted_73 = { class: "fv-plugins-message-container" }
const _hoisted_74 = { class: "fv-help-block" }
const _hoisted_75 = { class: "row mb-6" }
const _hoisted_76 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_77 = { class: "col-lg-8 fv-row" }
const _hoisted_78 = ["placeholder"]
const _hoisted_79 = { class: "fv-plugins-message-container" }
const _hoisted_80 = { class: "fv-help-block" }
const _hoisted_81 = { class: "row mb-6" }
const _hoisted_82 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_83 = { class: "col-lg-8 fv-row" }
const _hoisted_84 = ["placeholder"]
const _hoisted_85 = { class: "fv-plugins-message-container" }
const _hoisted_86 = { class: "fv-help-block" }
const _hoisted_87 = { class: "row mb-6" }
const _hoisted_88 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_89 = { class: "col-lg-8 fv-row" }
const _hoisted_90 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_91 = { class: "row mb-6" }
const _hoisted_92 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_93 = { class: "col-lg-8 fv-row" }
const _hoisted_94 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_95 = {
  key: 0,
  class: "card-footer d-flex justify-content-end py-6 px-9"
}
const _hoisted_96 = {
  type: "submit",
  id: "kt_package_create_details_submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_97 = { class: "indicator-label" }
const _hoisted_98 = { class: "indicator-progress" }
const _hoisted_99 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_el_color_picker = _resolveComponent("el-color-picker")!
  const _component_Form = _resolveComponent("Form")!

  return (_ctx.can('create', 'payments'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.translate('adPackagesDetails')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Form, {
            class: "form",
            onSubmit: _ctx.onSubmitCreate,
            "validation-schema": _ctx.packageSchema
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.translate('arabicTitle')) + ": ", 1),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "titleAr",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('packageNameArLang'),
                      disabled: _ctx.createdPackage
                    }, null, 8, ["placeholder", "disabled"]),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_ErrorMessage, { name: "titleAr" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.translate('englishTitle')) + ": ", 1),
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "titleEn",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('packageNameEnLang'),
                      disabled: _ctx.createdPackage
                    }, null, 8, ["placeholder", "disabled"]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_component_ErrorMessage, { name: "titleEn" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.translate('descriptionEn')) + ": ", 1),
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_Field, {
                      type: "textarea",
                      name: "descriptionEn",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('descriptionEn')
                    }, null, 8, ["placeholder"]),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createVNode(_component_ErrorMessage, { name: "descriptionEn" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.translate('descriptionAr')) + ": ", 1),
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_component_Field, {
                      type: "textarea",
                      name: "descriptionAr",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('descriptionAr')
                    }, null, 8, ["placeholder"]),
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, [
                        _createVNode(_component_ErrorMessage, { name: "descriptionAr" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.translate('price')) + ": ", 1),
                  _createElementVNode("div", _hoisted_29, [
                    _createVNode(_component_Field, {
                      type: "number",
                      name: "price",
                      modelValue: _ctx.price,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.price) = $event)),
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('price')
                    }, null, 8, ["modelValue", "placeholder"]),
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        _createVNode(_component_ErrorMessage, { name: "price" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.translate('discountPercentage')) + ": ", 1),
                  _createElementVNode("div", _hoisted_34, [
                    _createVNode(_component_Field, {
                      type: "number",
                      name: "discountPercentage",
                      modelValue: _ctx.discountPercentage,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.discountPercentage) = $event)),
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('discountPercentage')
                    }, null, 8, ["modelValue", "placeholder"]),
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("div", _hoisted_36, [
                        _createVNode(_component_ErrorMessage, { name: "discountPercentage" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("label", _hoisted_38, _toDisplayString(_ctx.translate('offeredPrice')) + ": ", 1),
                  _createElementVNode("div", _hoisted_39, [
                    _createVNode(_component_Field, {
                      type: "number",
                      name: "offeredPrice",
                      modelValue: _ctx.offeredPrice,
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('offeredPrice')
                    }, null, 8, ["modelValue", "placeholder"]),
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("div", _hoisted_41, [
                        _createVNode(_component_ErrorMessage, { name: "offeredPrice" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("label", _hoisted_43, _toDisplayString(_ctx.translate('type')) + ": ", 1),
                  _createElementVNode("div", _hoisted_44, [
                    _createVNode(_component_Field, {
                      as: "select",
                      name: "type",
                      class: "form-select form-control-lg form-control-solid"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("option", _hoisted_45, _toDisplayString(_ctx.translate('selectType')), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.packageTypeOptions, ([key, value]) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: value,
                            value: value
                          }, _toDisplayString(_ctx.translate(key)), 9, _hoisted_46))
                        }), 128))
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_47, [
                      _createElementVNode("div", _hoisted_48, [
                        _createVNode(_component_ErrorMessage, { name: "type" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("label", _hoisted_50, _toDisplayString(_ctx.translate('iveCredits')) + ": ", 1),
                  _createElementVNode("div", _hoisted_51, [
                    _createVNode(_component_Field, {
                      type: "number",
                      name: "iveCredits",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('iveCredits')
                    }, null, 8, ["placeholder"]),
                    _createElementVNode("div", _hoisted_52, [
                      _createElementVNode("div", _hoisted_53, [
                        _createVNode(_component_ErrorMessage, { name: "iveCredits" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_54, [
                  _createElementVNode("label", _hoisted_55, _toDisplayString(_ctx.translate('adsCredits')) + ": ", 1),
                  _createElementVNode("div", _hoisted_56, [
                    _createVNode(_component_Field, {
                      type: "number",
                      name: "adsCredits",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('adsCredits')
                    }, null, 8, ["placeholder"]),
                    _createElementVNode("div", _hoisted_57, [
                      _createElementVNode("div", _hoisted_58, [
                        _createVNode(_component_ErrorMessage, { name: "adsCredits" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_59, [
                  _createElementVNode("label", _hoisted_60, _toDisplayString(_ctx.translate('daysCovered')) + ": ", 1),
                  _createElementVNode("div", _hoisted_61, [
                    _createVNode(_component_Field, {
                      type: "number",
                      name: "daysCovered",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('daysCovered')
                    }, null, 8, ["placeholder"]),
                    _createElementVNode("div", _hoisted_62, [
                      _createElementVNode("div", _hoisted_63, [
                        _createVNode(_component_ErrorMessage, { name: "daysCovered" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_64, [
                  _createElementVNode("label", _hoisted_65, _toDisplayString(_ctx.translate('sort')) + ": ", 1),
                  _createElementVNode("div", _hoisted_66, [
                    _createVNode(_component_Field, {
                      type: "number",
                      name: "sort",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('sort')
                    }, null, 8, ["placeholder"]),
                    _createElementVNode("div", _hoisted_67, [
                      _createElementVNode("div", _hoisted_68, [
                        _createVNode(_component_ErrorMessage, { name: "sort" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_69, [
                  _createElementVNode("label", _hoisted_70, _toDisplayString(_ctx.translate('color')) + ": ", 1),
                  _createElementVNode("div", _hoisted_71, [
                    _createVNode(_component_Field, { name: "color" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            autocomplete: "off",
                            class: "form-control form-control-lg form-control-solid",
                            placeholder: _ctx.translate('color'),
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.color) = $event))
                          }, null, 8, _hoisted_72), [
                            [_vModelText, _ctx.color]
                          ]),
                          _createVNode(_component_el_color_picker, {
                            modelValue: _ctx.color,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.color) = $event))
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_73, [
                      _createElementVNode("div", _hoisted_74, [
                        _createVNode(_component_ErrorMessage, { name: "color" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_75, [
                  _createElementVNode("label", _hoisted_76, _toDisplayString(_ctx.translate('viewColor')) + ": ", 1),
                  _createElementVNode("div", _hoisted_77, [
                    _createVNode(_component_Field, { name: "viewColor" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            autocomplete: "off",
                            class: "form-control form-control-lg form-control-solid",
                            placeholder: _ctx.translate('viewColor'),
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.viewColor) = $event))
                          }, null, 8, _hoisted_78), [
                            [_vModelText, _ctx.viewColor]
                          ]),
                          _createVNode(_component_el_color_picker, {
                            modelValue: _ctx.viewColor,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.viewColor) = $event))
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_79, [
                      _createElementVNode("div", _hoisted_80, [
                        _createVNode(_component_ErrorMessage, { name: "viewColor" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_81, [
                  _createElementVNode("label", _hoisted_82, _toDisplayString(_ctx.translate('priceColor')) + ": ", 1),
                  _createElementVNode("div", _hoisted_83, [
                    _createVNode(_component_Field, { name: "priceColor" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            autocomplete: "off",
                            class: "form-control form-control-lg form-control-solid",
                            placeholder: _ctx.translate('priceColor'),
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.priceColor) = $event))
                          }, null, 8, _hoisted_84), [
                            [_vModelText, _ctx.priceColor]
                          ]),
                          _createVNode(_component_el_color_picker, {
                            modelValue: _ctx.priceColor,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.priceColor) = $event))
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_85, [
                      _createElementVNode("div", _hoisted_86, [
                        _createVNode(_component_ErrorMessage, { name: "priceColor" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_87, [
                  _createElementVNode("label", _hoisted_88, _toDisplayString(_ctx.translate('isMostPopular')) + ": ", 1),
                  _createElementVNode("div", _hoisted_89, [
                    _createElementVNode("label", _hoisted_90, [
                      _createVNode(_component_Field, {
                        class: "form-check-input",
                        name: "isMostPopular",
                        type: "checkbox",
                        value: true,
                        checked: "checked"
                      })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_91, [
                  _createElementVNode("label", _hoisted_92, _toDisplayString(_ctx.translate('singleUse')) + ": ", 1),
                  _createElementVNode("div", _hoisted_93, [
                    _createElementVNode("label", _hoisted_94, [
                      _createVNode(_component_Field, {
                        class: "form-check-input",
                        name: "singleUse",
                        type: "checkbox",
                        value: true,
                        checked: "checked"
                      })
                    ])
                  ])
                ])
              ]),
              (!_ctx.createdPackage)
                ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
                    _createElementVNode("button", {
                      type: "reset",
                      class: "btn btn-white btn-active-light-primary me-2",
                      onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                    }, _toDisplayString(_ctx.translate('discard')), 1),
                    _createElementVNode("button", _hoisted_96, [
                      _createElementVNode("span", _hoisted_97, _toDisplayString(_ctx.translate('saveChanges')), 1),
                      _createElementVNode("span", _hoisted_98, [
                        _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                        _hoisted_99
                      ])
                    ], 512)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ])
      ]))
    : _createCommentVNode("", true)
}